<template>
  <div>Redirecting...</div>
</template>

<script>

export default {
  name: 'ChatRedirect',
  props: {
    room: { type: String, required: true },
    lastId: { type: Number, required: true },
  },
  computed: {
    type() {
      let type = 'unknown';
      if (/^_group\./.test(this.room)) {
        type = 'group';
      } else if (/^_m2m\./.test(this.room)) {
        type = 'member';
      } else if (/^_m2l\./.test(this.room)) {
        type = 'post';
      }
      return type;
    },
  },
  async created() {
    if (this.type === 'group') {
      this.subject = await this.group(this.room);
    } else if (this.type === 'post') {
      this.subject = await this.post(this.room);
    } else if (this.type === 'member') {
      this.subject = await this.otherUser(this.room);
    }

    this.redirect();
  },
  methods: {
    async redirect() {
      let route = null;
      if (this.subject) {
        if (this.lastId) {
          await this.$root.markChatRead(this.lastId);
        }

        if (this.type === 'group') {
          route = {
            name: 'chat_group',
            params: { id: this.subject.id },
          };
        } else if (this.type === 'member') {
          route = {
            name: 'message_profile',
            params: { id: this.subject.id },
          };
        } else if (this.type === 'post') {
          route = {
            name: 'message_listing',
            params: {
              id: this.subject.id,
              user: this.secondId(this.room),
            },
          };
        }
      } else {
        route = '/';
      }
      if (route) {
        this.$router.replace(route);
      }
    },
    group(room) {
      const id = parseInt(room.slice(7), 10);
      return this.userGroups.find(g => g.id === id);
    },
    async otherUser(room) {
      const id = this.otherId(room);
      const response = await this.api({ url: `users/${id}/` });
      return response.body;
    },
    async post(room) {
      const id = this.firstId(room);
      const response = await this.api({ url: `posts/${id}/` });
      return response.body;
    },
    otherId(room) {
      return room.slice(5).split('.').map(i => parseInt(i, 10)).filter(i => i !== this.userData.id)[0];
    },
    firstId(room) {
      return parseInt(room.slice(5).split('.')[0], 10);
    },
    secondId(room) {
      return room.slice(5).split('.').map(i => parseInt(i, 10))[1];
    },
  },
};
</script>
